import React from "react";
import { useTranslation } from "react-i18next";
import "./BlogHero.css";
import blogHeroImage from "../../../../assets/images/Blog/bloghero.jpg";

const BlogHero = () => {
  const { t } = useTranslation();

  return (
    <section className="blogHero" aria-label="Blog hero">
      <div className="blogHero-bg">
        <img
          src={blogHeroImage}
          alt=""
          className="blogHero-bgImage"
          draggable={false}
        />
      </div>

      <div className="blogHero-overlay" aria-hidden="true" />

      <div className="blogHero-inner">
        <h1>{t("sections.blog.heroTitle")}</h1>
      </div>
    </section>
  );
};

export default BlogHero;
